import React from 'react';
import { Link } from 'react-router-dom';
import Header from './shared/Header';
import Navigation from './shared/Navigation';
import { getRandomColor } from '../utils/colors';
const WorkshopsPage = () => {
  return <div className="min-h-screen bg-[#faf9f7] text-[#333333] font-serif" data-id="element-693">
      <Header data-id="element-694" />
      <main className="flex min-h-screen pt-24 px-6 pb-16" data-id="element-695">
        <div className="flex flex-col md:flex-row w-full max-w-6xl mx-auto" data-id="element-696">
          <div className="w-full md:w-1/4 mb-8 md:mb-0" data-id="element-697">
            <Navigation data-id="element-698" />
          </div>
          <div className="w-full md:w-3/4 md:pl-8" data-id="element-699">
            <div className="max-w-2xl" data-id="element-700">
              <div className="mb-8" data-id="element-701">Workshops for 2026</div>
              <div className="mb-8" data-id="element-702">
                <div className="mb-1 line-through" data-id="element-703">
                  The Winter Practice Workshop (Online)
                </div>
                <div className="mb-1 line-through" data-id="element-704">
                  Saturdays 9am - 12pm EST
                </div>
                <div className="mb-1 line-through" data-id="element-705">
                  January 24th - February 21st, 2026
                </div>
                <div data-id="element-706">
                  <span className="line-through" data-id="element-707">
                    <Link to="/winter-practice-workshop" className="transition-colors duration-200" onMouseEnter={e => {
                    e.currentTarget.style.color = getRandomColor();
                  }} onMouseLeave={e => {
                    e.currentTarget.style.color = '#333333';
                  }} data-id="element-708">
                      Register here
                    </Link>
                  </span>{' '}
                  <span className="text-[#333333]" data-id="element-709">SOLD OUT</span>
                </div>
              </div>
              <div className="mb-8" data-id="element-710">
                <div className="mb-1 line-through" data-id="element-711">
                  Try Something New: 100 Images in Two Days
                </div>
                <div className="mb-1 line-through" data-id="element-712">
                  In-Person @{' '}
                  <a href="https://www.penumbrafoundation.org/" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" onMouseEnter={e => {
                  e.currentTarget.style.color = getRandomColor();
                }} onMouseLeave={e => {
                  e.currentTarget.style.color = '#333333';
                }} data-id="element-713">
                    Penumbra Foundation
                  </a>
                </div>
                <div className="mb-1 line-through" data-id="element-714">
                  April 22nd - April 24th, 2026
                </div>
                <span className="line-through" data-id="element-715">
                  <a href="https://www.penumbrafoundation.org/workshops/try-something-new-100-images-in-two-days" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" onMouseEnter={e => {
                  e.currentTarget.style.color = getRandomColor();
                }} onMouseLeave={e => {
                  e.currentTarget.style.color = '#333333';
                }} data-id="element-716">
                    Register here
                  </a>
                </span>
              </div>
              <div className="mb-8" data-id="element-717">
                <div className="mb-1" data-id="element-718">Saturday Critique Group 1 (Online)</div>
                <div className="mb-1" data-id="element-719">Every four weeks, starting June 20th</div>
                <div className="mb-1" data-id="element-720">9am - 11:30am EST</div>
                <Link to="/saturday-critique-group" className="transition-colors duration-200" onMouseEnter={e => {
                e.currentTarget.style.color = getRandomColor();
              }} onMouseLeave={e => {
                e.currentTarget.style.color = '#333333';
              }} data-id="element-721">
                  Register here
                </Link>
              </div>
              <div className="mb-8" data-id="element-722">
                <div className="mb-1" data-id="element-723">
                  The Sum of the Parts: A Writing and Photography Workshop
                </div>
                <div className="mb-1" data-id="element-724">
                  Co-led by{' '}
                  <a href="https://www.vivianewing.com/" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" onMouseEnter={e => {
                  e.currentTarget.style.color = getRandomColor();
                }} onMouseLeave={e => {
                  e.currentTarget.style.color = '#333333';
                }} data-id="element-725">
                    Vivian Ewing
                  </a>
                </div>
                <div className="mb-1" data-id="element-726">
                  In-Person @{' '}
                  <a href="https://www.mainemedia.edu/workshops/" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" onMouseEnter={e => {
                  e.currentTarget.style.color = getRandomColor();
                }} onMouseLeave={e => {
                  e.currentTarget.style.color = '#333333';
                }} data-id="element-727">
                    Maine Media Workshops
                  </a>
                </div>
                <div className="mb-1" data-id="element-728">August 24th - August 28th, 2026</div>
                <a href="https://www.mainemedia.edu/workshops/item/the-sum-of-the-parts-a-writing-and-photography-workshop/" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" onMouseEnter={e => {
                e.currentTarget.style.color = getRandomColor();
              }} onMouseLeave={e => {
                e.currentTarget.style.color = '#333333';
              }} data-id="element-729">
                  Register here
                </a>
              </div>
              <div className="mb-8" data-id="element-730">
                <div className="mb-1" data-id="element-731">
                  Photography & Storytelling: Thinking About the Photo Book
                </div>
                <div className="mb-1" data-id="element-732">
                  In-Person @{' '}
                  <a href="https://www.mainemedia.edu/workshops/" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" onMouseEnter={e => {
                  e.currentTarget.style.color = getRandomColor();
                }} onMouseLeave={e => {
                  e.currentTarget.style.color = '#333333';
                }} data-id="element-733">
                    Maine Media Workshops
                  </a>
                </div>
                <div className="mb-1" data-id="element-734">
                  September 21st - September 25th, 2026
                </div>
                <div data-id="element-735">
                  <a href="https://www.mainemedia.edu/workshops/item/photography-and-storytelling-thinking-about-the-photo-book/" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" onMouseEnter={e => {
                  e.currentTarget.style.color = getRandomColor();
                }} onMouseLeave={e => {
                  e.currentTarget.style.color = '#333333';
                }} data-id="element-736">
                    Register here
                  </a>
                </div>
              </div>
              <div className="mb-12" data-id="element-737">
                <div data-id="element-738">
                  One-on-one mentorship follows the{' '}
                  <a href="https://santafeworkshops.com/sfw-online/mentorships/" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" onMouseEnter={e => {
                  e.currentTarget.style.color = getRandomColor();
                }} onMouseLeave={e => {
                  e.currentTarget.style.color = '#333333';
                }} data-id="element-739">
                    Santa Fe Mentorship Level 1
                  </a>{' '}
                  model. Email me directly to enquire.
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>;
};
export default WorkshopsPage;